import React, { useCallback } from 'react';
import { isElectron } from '@web-chat-core/ui-kit/helpers/electron';

const urlRegex = /([a-zA-Z][a-zA-Z0-9+.-]*:\/\/[^\s<>"]+)/;
const allowedProtocols = ['http://', 'https://', 'mailto:'];

const checkUrlForAllowedProtocols = (messagePart: string) => {
    if (!urlRegex.test(messagePart)) return false;
    return allowedProtocols.some((protocol) => messagePart.toLowerCase().startsWith(protocol));
};

type MessageContentProps = {
    text: string;
    sid: string;
};

export const MessageContent = ({ text, sid }: MessageContentProps) => {
    const parts = text.split(urlRegex);

    const handleLinkClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
        e.preventDefault();
        if (isElectron) {
            return window.electronApi.ipcRenderer.openExternalUrl(href, true);
        }
        return window.open(href, '_blank');
    }, []);

    return (
        <>
            {parts.map((part, index) => {
                const hasAllowedProtocol = checkUrlForAllowedProtocols(part);
                if (hasAllowedProtocol) {
                    return (
                        <a
                            key={`${sid}_${index}`}
                            onClick={(e) => handleLinkClick(e, part)}
                            href={part}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            {part}
                        </a>
                    );
                }
                return <span key={`${sid}_${index}`}>{part}</span>;
            })}
        </>
    );
};

MessageContent.displayName = 'MessageContent';
